import { ArticlePublicationStatus } from '@tabeeb/contracts/microservices/swagger-article-service'

export const ArticlePublicationStatusDisplayName: Record<ArticlePublicationStatus, string> = {
  [ArticlePublicationStatus.Draft]: 'Draft',
  [ArticlePublicationStatus.Published]: 'Published',
}

export { ArticlePublicationStatus }
